module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("e8zl5"))).then(() => parcelRequire('gjSVA'));